export const BONUS = 'bonus';
export const DEFAULT = 'default';
